<template>
  <div class="breadcrumb" :style="borderStyle">
    <div class="breadcrumb-route">
      <template v-for="(item, index) in breadcrumbData">
        <router-link
          v-if="item.isRoute"
          :class="[
            'breadcrumb-nav',
            { arrow: index !== breadcrumbData.length - 1 },
          ]"
          :key="`${item.name}${index}`"
          :to="item.to"
          >{{ item.name }}</router-link
        >
        <div v-else class="breadcrumb-label" :key="`${item.name}${index}`">
          {{ item.name }}
        </div>
      </template>
    </div>
    <Dropdown class="dropdown-menu" trigger="click" @on-click="onMenuChange">
      <Button type="primary">
        控制中心
        <Icon type="ios-arrow-down"></Icon>
      </Button>
      <DropdownMenu slot="list">
        <DropdownItem name="user">控制台</DropdownItem>
        <DropdownItem name="domain">域名管理</DropdownItem>
        <DropdownItem name="finance">资金管理</DropdownItem>
        <DropdownItem name="account">账户管理</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>
<script>
export default {
  name: "breadcrumb",
  props: {
    borderStyle: {
      type: Object,
      default: () => {
        return {
          borderBottom: "1px solid #E9E9E9",
        };
      },
    },
  },
  computed: {
    breadcrumbData() {
      return this.$route.meta.breadcrumbData;
    },
  },
  methods:{
    onMenuChange(value){
      switch (value) {
        case "user":
          if(this.$route.name !== 'user'){
            this.$router.push('/user');
          }
          break;
        case "domain":
          if(this.$route.name !== 'domain'){
            this.$router.push('/user/domain');
          }
          break;
        case "finance":
          if(this.$route.name !== 'financeAccount'){
            this.$router.push('/user/finance/account');
          }
          break;
        case "account":
          if(this.$route.name !== 'account'){
            this.$router.push('/user/account');
          }
          break;
        
      }
    }
  },
};
</script>
<style lang="less" scoped>
.breadcrumb {
  padding: 25px 0;
  .flex(space-between, center);
  .breadcrumb-route {
    .flex(space-between, center);
    .breadcrumb-nav {
      color: #333333;
      font-size: 16px;
      font-weight: 400;
      line-height: 21px;
    }
    .breadcrumb-label {
      font-size: 16px;
      color: #288DF0;
      padding: 6px 15px;
      border-radius: 8px;
      background-color: #E8F3FE;
    }
  }
  .arrow {
    &::after {
      content: "\003E";
      margin: 0 10px;
    }
  }
  .dropdown-menu /deep/ {
    .ivu-btn-primary {
      background-color: #fff;
      border-color: #E9E9E9;
      color: #333333;
    }
    .ivu-btn-primary:hover {
      border-color: #288DF0;
      color: #288DF0;
    }
    .ivu-btn-primary:focus {
      border-color: #288DF0;
      box-shadow: none;
    }
    /deep/ .ivu-select-dropdown {
      background-color: #fff;
      padding: 0;
      .ivu-dropdown-item {
        color: #333333;
        text-align: center;
        &:not(:last-child) {
          border-bottom: 1px solid #F1F1F7;
        }
        &:hover{
            background: #E8F3FE;
            color: #288DF0;
        }
      }
    }
  }
}
</style>